import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/confirm_btn.webp'
import _imports_1 from '@/assets/imgs/confirm_btn.png'
import _imports_2 from '@/assets/imgs/cancel_btn.webp'
import _imports_3 from '@/assets/imgs/cancel_btn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-f3320f20")

_pushScopeId("data-v-f3320f20")
const _hoisted_1 = _imports_0
const _hoisted_2 = _imports_2
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "br" }, null, -1)
const _hoisted_4 = { class: "bet-ratio" }
const _hoisted_5 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_1
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/confirm_btn.png"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_2
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/cancel_btn.png"
}, null, -1)
const _hoisted_9 = { class: "coin" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_app_svg = _resolveComponent("app-svg")

  return (_openBlock(), _createBlock("div", {
    class: ["mobile-bet-area-root", _ctx.color]
  }, [
    _createVNode("div", {
      class: ["highlight", { flashing: _ctx.showFlash }],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBetClicked && _ctx.handleBetClicked(...args)))
    }, null, 2),
    _createVNode("span", {
      class: ["label", { offset: _ctx.offSet !== -1, 'is-gray-mode': _ctx.isGrayMode }]
    }, [
      _createTextVNode(_toDisplayString(_ctx.betLabel) + " ", 1),
      _hoisted_3,
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.betRatio), 1)
    ], 2),
    (
                _ctx.showConfirmCancelButton &&
                    _ctx.hasUnConfirmedBet &&
                    _ctx.betType === _ctx.currentIndex
            )
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["cancel_confirm", { offset: _ctx.offSet !== -1 }]
        }, [
          _createVNode("picture", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.confirmBet()), ["stop"]))
          }, [
            _hoisted_5,
            _hoisted_6
          ]),
          _createVNode("picture", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelBet && _ctx.cancelBet(...args)), ["stop"]))
          }, [
            _hoisted_7,
            _hoisted_8
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.needToDisPlayAmount)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: ["bet-coin", {
                offset: _ctx.offSet !== -1,
                'no-bet': _ctx.hasNoBet,
                'has-confirmed-bet': _ctx.hasBetConfirmedBet,
                'has-unconfirm-bet': _ctx.hasUnConfirmedBet
            }]
        }, [
          _createVNode(_component_app_svg, {
            box: '0 0 67 57',
            id: 'chip',
            className: 'chip-svg',
            fill: 'rgb(221, 194, 140)',
            stroke: 'rgb(221, 194, 140)'
          }, null, 8, ["fill", "stroke"]),
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.amount), 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
})